module.exports = __webpack_public_path__ + "metroIcons_light.8fe485dd7a6c9b7a7d06.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Synergy/Projects/SFE/Synergy.UI/node_modules/metrojs/release/MetroJs.Full/images/metroIcons_light.jpg
// module id = ../../../../metrojs/release/MetroJs.Full/images/metroIcons_light.jpg
// module chunks = styles